<template>
  <div class="activity">
    <content :is="getType" :activity="activity"></content>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { loadImage } from '@src/helpers/image-helper'
import shave from 'shave'
import urlParser from 'js-video-url-parser'
import Event from './content/Event'
import Media from './content/Media'
import Comment from './content/Comment'
import Create from './content/Create'
import ProductActivity from './content/ProductActivity'
import SharedPost from './content/SharedPost'
import SharedUrl from './content/SharedUrl'

export default {
  name: 'item-body',
  components: {
    Event,
    Media,
    Comment,
    Create,
    SharedPost,
    SharedUrl,
    ProductActivity,
  },
  props: {
    activity: null,
  },
  created() {},
  watch: {
    activity: function (to) {
      this.activity = to
    },
  },
  computed: {
    getType() {
      if (
        this.activity.action_name == 'create' ||
        this.activity.action_name === 'join'
      ) {
        return 'Create'
      } else if (
        [
          'post_create',
          'post_update',
          'post_like',
          'post_comment',
          'post_comment_like',
          'event_create',
          'event_join',
          'event_update',
          'event_like',
          'event_comment',
          'event_comment_like',
        ].includes(this.activity.action_name.toLowerCase())
      ) {
        return 'Event'
      } else if (
        ['product_create', 'product_update'].includes(
          this.activity.action_name.toLowerCase()
        )
      ) {
        return 'ProductActivity'
      } else if (this.activity.action_name === 'media') {
        return 'Media'
      } else if (
        this.activity.action_name === 'wall' &&
        this.activity.object.type === 'comments'
      ) {
        return 'SharedPost'
      } else if (
        this.activity.action_name === 'wall' &&
        this.activity.object.type === 'article'
      ) {
        return 'SharedUrl'
      } else {
        console.log(this.activity.action_name)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// .object-image-block {
//     width: 128px;
//     max-height: 128px;
//     overflow: hidden;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }
.activity img {
  width: 100%;
}
.object-title {
  // font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #3c4144;
}
.object-description {
  // font-weight: normal;
  font-size: 12px;
  line-height: 21px;
  color: #777;
}
.creat-title {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  font-size: 14px;
  color: #3c4144;
  line-height: 21px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.creat-description {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  font-size: 12px;
  color: #777;
  line-height: 21px;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media only screen and (min-width: 1200px) {
  .commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis-two-line {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    height: 41px;
    margin: 0 auto;
    font-size: 14px;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis-four-line {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    height: 82px;
    margin: 0 auto;
    font-size: 12px;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 1024px) {
  .commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis-two-line {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    height: 42px;
    margin: 0 auto;
    font-size: 14px;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis-four-line {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    height: 82px;
    margin: 0 auto;
    font-size: 12px;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media only screen and (max-width: 1023px) and (min-width: 768px) {
  .commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis-two-line {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    height: 42px;
    margin: 0 auto;
    font-size: 14px;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis-four-line {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    height: 82px;
    margin: 0 auto;
    font-size: 12px;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media only screen and (max-width: 767px) {
  .commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis-two-line {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    height: 25px;
    margin: 0 auto;
    font-size: 12px;
    line-height: 12px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis-four-line {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    height: 46px;
    margin: 0 auto;
    font-size: 9px;
    line-height: 11px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  //   .object-image-block {
  //       margin-right: 5px;
  //   }
  //   .object-image-block {
  //     width: 128px;
  //     max-height: 128px;
  //     overflow: hidden;
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //   }
}
</style>
